module.exports = __webpack_public_path__ + "static/img/slogan-large.cc1da12e.png";